import { Component, OnInit } from '@angular/core';
import { CollectionService } from 'src/app/core/services/collection.service';
import { Location } from 'src/app/core/models/location.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CollectionModalComponent } from '../collectionModal/collection-modal.component';
import { SalesRepService } from 'src/app/core/services/sales-rep.service';
import { LoginService } from 'src/app/core/services/login.service';
import { UserType } from 'src/app/core/models/userType.models';



import { Router } from '@angular/router';

@Component({
  selector: 'app-pending-collections',
  templateUrl: './pending-collections.component.html',
  styleUrls: ['./pending-collections.component.scss']
})
export class PendingCollectionsComponent implements OnInit {
  pendingLocations: Location[] = [];
  isLoading = false;
  private assignedSalesRepIds = new Set<string>();

  constructor(
    private collectionService: CollectionService,
    private salesRepService: SalesRepService,
    private loginService: LoginService,
    private router: Router,
    private modalService: NgbModal
  ) {}

  async ngOnInit(): Promise<void> {
    await this.loadCollectorAssignments();
    this.loadPendingLocations();
  }

loadPendingLocations(): void {
  this.isLoading = true;

  this.collectionService.getPendingLocationsForCollector().subscribe({
    next: (locations: any[]) => {
      const hydrated = locations.map(loc => Object.assign(new Location(), loc));
      this.pendingLocations = this.filterLocationsForCollector(hydrated)
        .filter((location) => this.isEnabledLocation(location));
      this.isLoading = false;
    },
    error: (err) => {
      console.error('Error loading pending locations:', err);
      this.isLoading = false;
    }
  });
}

private async loadCollectorAssignments(): Promise<void> {
  if (this.loginService.userType !== UserType.COLLECTOR || !this.loginService.userId) {
    return;
  }

  try {
    const salesReps = await this.salesRepService.getAll();
    this.assignedSalesRepIds = new Set(
      (salesReps || [])
        .filter((rep) => this.normalizeId(rep.collectorId || rep.collector?.id) === this.normalizeId(this.loginService.userId))
        .map((rep) => this.normalizeId(rep.id))
        .filter((id) => !!id)
    );
  } catch (error) {
    console.error('Failed to load collector assignments:', error);
    this.assignedSalesRepIds.clear();
  }
}

private filterLocationsForCollector(locations: Location[]): Location[] {
  if (this.loginService.userType !== UserType.COLLECTOR) {
    return locations;
  }

  if (!this.assignedSalesRepIds.size) {
    return [];
  }

  return locations.filter((location) => this.assignedSalesRepIds.has(this.normalizeId(location?.salesRep?.id)));
}

private isEnabledLocation(location: Location): boolean {
  return location?.enabled === true || location?.enabled === 1 || `${location?.enabled}`.toLowerCase() === 'true';
}

private normalizeId(value?: string | null): string {
  return (value || '').replace(/-/g, '').toLowerCase();
}

openCollectionModal(locationId: string): void {
  const modalRef = this.modalService.open(CollectionModalComponent, {
    size: 'lg',
    backdrop: 'static'
  });

  modalRef.componentInstance.selectedLocationId = locationId;
  void modalRef.result
    .finally(() => this.loadPendingLocations())
    .catch(() => undefined);
}

}
